import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import React from 'react'
import { CMBCEnhancedPhoneInput } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingComponents'
import { GRID_CONFIG } from '../utils/patientFormConfig'
import { ArrayFormField } from './FormField'
import { usePatientFormI18n } from '../utils/patientFormI18n'

export const PatientAlternativeMobiles = ({
  alternativeMobiles = [],
  onAdd,
  onUpdate,
  onRemove,
  editMode = true,
  validationHook,
  label = 'Alternative Mobile Numbers',
  helperText = '',
  gridConfig = GRID_CONFIG,
}) => {
  const { copy } = usePatientFormI18n()

  const renderAlternativeMobile = (mobile, index, { onUpdate, onRemove, disabled }) => {
    const validation = validationHook?.getAlternativeMobileValidation(index)

    return (
      <div
        key={index}
        className="d-flex align-items-start gap-2 mb-2"
        style={{ width: '100%', flexWrap: 'wrap' }}
      >
        <div style={{ flex: '1 1 220px', minWidth: 0 }}>
          <div className="d-flex flex-column">
            <CMBCEnhancedPhoneInput
              disabled={disabled}
              placeholder={copy.alternateMobilePlaceholder}
              value={mobile || ''}
              fullWidth
              onChange={(value) => {
                if (!disabled) {
                  onUpdate(index, value)
                }
              }}
            />
            {validation?.showError && (
              <small className="text-danger">{validation.errorMessage}</small>
            )}
          </div>
        </div>

        <DeleteOutlineIcon
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            marginTop: '10px',
          }}
          onClick={() => {
            if (!disabled) {
              onRemove(index)
            }
          }}
        />
      </div>
    )
  }

  return (
    <ArrayFormField
      label={label}
      helperText={helperText}
      items={alternativeMobiles}
      onAdd={editMode ? onAdd : undefined}
      onRemove={editMode ? onRemove : undefined}
      onUpdate={editMode ? onUpdate : undefined}
      renderItem={renderAlternativeMobile}
      disabled={!editMode}
      gridConfig={gridConfig}
      AddIcon={AddCircleOutlineIcon}
    />
  )
}

export default PatientAlternativeMobiles
